import CenteredHeader from "./../../Molecules/CenteredHeader/CenteredHeader";
import TRANSPORTE_MANEJO_DE_FLOTAS_IMG from "../../../assets/img/TRANSPORTE_MANEJO_DE_FLOTAS_IMG.jpg";
import IndustryLightBlueSection from "./../../Organisms/IndustryLightBlueSection/IndustryLightBlueSection";
import IndustryBannerBgSection from "./../../Atoms/IndustryBannerBgSection/IndustryBannerBgSection";
import IndustryImageTextSection from "./../../Molecules/IndustryImageTextSection/IndustryImageTextSection";
import IndustryTwoButtonsSection from "./../../Atoms/IndustryTwoButtonsSection/IndustryTwoButtonsSection";
import CONTRUCCION_BANNER_RIGHT_IMG from "../../../assets/img/CONTRUCCION_BANNER_RIGHT_IMG.png";
import LAPTOP from "../../../assets/img/LAPTOP.png";
import TRANPORTE_DASHBOARD_IMG from "../../../assets/img/TRANPORTE_DASHBOARD_IMG.jpg";
import CONTRUCCION_ROUTE_IMG from "../../../assets/img/CONTRUCCION_ROUTE_IMG.jpg";
import IndustryFooterButtonSection from "./../../Atoms/IndustryFooterButtonSection/IndustryFooterButtonSection";
import content from "./content"
import { useLanguageCtx } from "../../../store/providers/LanguageContext";
import { useScrollCtx } from "../../../store/providers/ScrollContext";
import ChangeableHeaderV2 from "../../Molecules/ChangeableHeaderV2/ChangeableHeaderV2";

const IndustryTransporte = () => {
	const {language} = useLanguageCtx();
	const { dropdownHeader } = useScrollCtx();
	
	return (
		<>
			<ChangeableHeaderV2
				withTitle
				titleBanner={content[language].header_title}
				spanTitleYellow={content[language].header_span_title}
				appearSecondNavbar={dropdownHeader}
				route="transporte"
			/>

			<div className="top-space-section">
				<CenteredHeader
					yellowText={content[language].flotas_red_color}
					boldText={content[language].flotas_bold_title}
				/>
			</div>

			<div className="bottom-space-section max-width">
				<p className="body-18 center-text mt-30">
					{content[language].flotas_text}
				</p>
				<img
					src={TRANSPORTE_MANEJO_DE_FLOTAS_IMG}
					alt="Transporte"
					className="center mt-30"
				/>
			</div>

			<IndustryLightBlueSection
				yellowText={content[language].beneficios_red_title}
				boldText={content[language].beneficios_bold_title}
				checkText={content[language].beneficios_list}
			/>

			<IndustryBannerBgSection route="transporte">
				<IndustryImageTextSection
					inBanner
					switchOrder
					yellowText={content[language].caracteristicas_red_title}
					boldText={content[language].caracteristicas_bold_text}
					checkText={content[language].caracteristicas_list}
					image={{ img: CONTRUCCION_BANNER_RIGHT_IMG, alt: "Autobus" }}
				/>
			</IndustryBannerBgSection>

			<IndustryTwoButtonsSection bgColor="#F0F3F7" pt="80px" />

			<div
				className="top-space-section padding"
				style={{ backgroundColor: "#F0F3F7" }}
			>
				<CenteredHeader
					yellowText={content[language].funcionalidades_red_title}
					boldText={content[language].funcionalidades_bold_title}
				/>
			</div>

			<div
				className="top-space-section padding no-top-space-responsive pb-40"
				style={{ backgroundColor: "#F0F3F7" }}
			>
				<IndustryImageTextSection
					image={{
						img: LAPTOP,
						alt: "Tablet Mostrando un Mapa en Pantalla",
					}}
					boldText={content[language].funcionalidades_bold_text}
					paragraphs={content[language].funcionalidades_text}
					checkText={content[language].funcionalidades_list}
					responsiveImgPosition="last"
				/>
			</div>

			<div className="top-space-section">
				<IndustryImageTextSection
					switchOrder
					yellowText={content[language].dashboard_red_title}
					boldText={content[language].dashboard_bold_text}
					paragraphs={content[language].dashboard_text}
					checkText={content[language].dashboard_list}
					image={{
						img: TRANPORTE_DASHBOARD_IMG,
						alt: "Teléfono Mostrando un Mapa en Pantalla",
					}}
					imgRadius
				/>
			</div>

			<div className="top-space-section">
				<CenteredHeader
					yellowText={content[language].route_red_title}
					boldText={content[language].route_bold_title}
				/>
			</div>

			<div className="top-space-section no-top-space-responsive bottom-space-section">
				<IndustryImageTextSection
					image={{ img: CONTRUCCION_ROUTE_IMG, alt: "Autobus en Ciudad" }}
					boldText={content[language].route_bold_text}
					paragraphs={content[language].route_text}
					checkText={content[language].route_list}
					responsiveImgPosition="last"
				/>
			</div>

			<IndustryFooterButtonSection />
		</>
	);
};

export default IndustryTransporte;
